module.exports = __webpack_public_path__ + "static/kimberly-cruz-hero-small-f793641c35ba34fa5bda37baa23c0675.jpg";